// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.page-footer{
    background: var(--color-white);
    left: 0px;
    right: 0;
    bottom: 0;
    position: fixed;
    text-align: center;
    padding: 4px;
    font-size: 10px;
    border-top: 1px solid #e4e4e4;
    z-index: 3;
}
.wrapper.toggled .page-footer{
	left: 0;
}

@media (max-width: 768px) {
    .page-footer {
        display: none;
    }
}`, "",{"version":3,"sources":["webpack://./src/containers/footer/Footer.css"],"names":[],"mappings":"AAAA;IACI,8BAA8B;IAC9B,SAAS;IACT,QAAQ;IACR,SAAS;IACT,eAAe;IACf,kBAAkB;IAClB,YAAY;IACZ,eAAe;IACf,6BAA6B;IAC7B,UAAU;AACd;AACA;CACC,OAAO;AACR;;AAEA;IACI;QACI,aAAa;IACjB;AACJ","sourcesContent":[".page-footer{\r\n    background: var(--color-white);\r\n    left: 0px;\r\n    right: 0;\r\n    bottom: 0;\r\n    position: fixed;\r\n    text-align: center;\r\n    padding: 4px;\r\n    font-size: 10px;\r\n    border-top: 1px solid #e4e4e4;\r\n    z-index: 3;\r\n}\r\n.wrapper.toggled .page-footer{\r\n\tleft: 0;\r\n}\r\n\r\n@media (max-width: 768px) {\r\n    .page-footer {\r\n        display: none;\r\n    }\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
